import { apiSlice } from "../../apiSlice";


export const inventorySparePrioritySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updatePriority: builder.mutation({
      query: ({ seller_id, lot_id }) => ({
        url: "inventory/spares/priority",
        method: "PATCH",
        params: {
          seller_id,
          lot_id,
        },
      }),

      // 🔑 Important: refetch affected data
      invalidatesTags: ["InventorySellers", "InventoryLots"],
    }),
  }),
});

export const { useUpdatePriorityMutation } =
  inventorySparePrioritySlice;
